import apiClient from "../../../utilities/apiClient";

export const createDocRequest = (payload) => {
  return apiClient.post(apiClient.Urls.createDocRequest, payload, true);
};

export const getAdminDocRequests = () => {
  return apiClient.get(apiClient.Urls.getAdminDocRequests, "", true);
};

export const getAdminDocRequestDetails = (id) => {
  return apiClient.get(`${apiClient.Urls.getAdminDocRequestDetails}/${id}`, "", true);
};

export const getVendorDocRequests = () => {
  return apiClient.get(apiClient.Urls.getVendorDocRequests, "", true);
};

export const getAdminVendorDocRequests = (vendorId) => {
  return apiClient.get(`${apiClient.Urls.getAdminVendorDocRequests}/${vendorId}`, "", true);
};

export const uploadVendorDoc = (payload) => {
  return apiClient.post(apiClient.Urls.uploadVendorDoc, payload, true);
};

export const reviewVendorDoc = (payload) => {
  return apiClient.post(apiClient.Urls.reviewVendorDoc, payload, true);
};
